var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevelNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    stroke: "#F0B70D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9754 25.102V25.4974L25.3602 25.5885C25.9956 25.739 26.5616 26.0994 26.9666 26.6116C27.3716 27.1237 27.5919 27.7575 27.5919 28.4105C27.5919 29.0634 27.3716 29.6972 26.9666 30.2094C26.5616 30.7215 25.9956 31.082 25.3602 31.2324L24.9754 31.3235V31.719V34.971H24.4544V31.719V31.3235L24.0696 31.2324C23.4343 31.082 22.8683 30.7215 22.4633 30.2094C22.0582 29.6972 21.8379 29.0634 21.8379 28.4105C21.8379 27.7575 22.0582 27.1237 22.4633 26.6116C22.8683 26.0994 23.4343 25.739 24.0696 25.5885L24.4544 25.4974V25.102V16.502H24.9754V25.102Z",
    stroke: "#F6B119"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6375 19.752V20.1474L19.0223 20.2385C19.6577 20.389 20.2237 20.7495 20.6287 21.2616C21.0337 21.7737 21.2541 22.4076 21.2541 23.0605C21.2541 23.7134 21.0337 24.3473 20.6287 24.8594C20.2237 25.3715 19.6577 25.732 19.0223 25.8825L18.6375 25.9736V26.369V34.969H18.1165V26.369V25.9736L17.7317 25.8825C17.0964 25.732 16.5304 25.3715 16.1254 24.8594C15.7203 24.3473 15.5 23.7134 15.5 23.0605C15.5 22.4076 15.7203 21.7737 16.1254 21.2616C16.5304 20.7495 17.0964 20.389 17.7317 20.2385L18.1165 20.1474V19.752V16.5H18.6375V19.752Z",
    stroke: "#F6B119"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3133 19.752V20.1474L31.6981 20.2385C32.3334 20.389 32.8995 20.7495 33.3045 21.2616C33.7095 21.7737 33.9298 22.4076 33.9298 23.0605C33.9298 23.7134 33.7095 24.3473 33.3045 24.8594C32.8995 25.3715 32.3334 25.732 31.6981 25.8825L31.3133 25.9736V26.369V34.969H30.7923V26.369V25.9736L30.4075 25.8825C29.7722 25.732 29.2062 25.3715 28.8011 24.8594C28.3961 24.3473 28.1758 23.7134 28.1758 23.0605C28.1758 22.4076 28.3961 21.7737 28.8011 21.2616C29.2062 20.7495 29.7722 20.389 30.4075 20.2385L30.7923 20.1474V19.752V16.5H31.3133V19.752Z",
    stroke: "#F6B119"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelNotification);
export default __webpack_public_path__ + "static/media/Level-notification.c58fab935bb1294f6eebf9248fb954ef.svg";
export { ForwardRef as ReactComponent };